import { put, call, take, fork } from 'redux-saga/effects'
import { getCollectionLandingPageSuccess } from 'src/reducers/collection/action'
import { getCollectionLandingPageService } from 'src/api/collection'
import { GET_COLLECTION_LANDING_PAGE } from 'src/reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getCollectionLandingPage(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(getCollectionLandingPageService, id)

    yield put(getCollectionLandingPageSuccess(response.data))
    yield put(operationSuccess())

    if (callback) callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getCollectionLandingPageWatcher() {
  while (true) {
    const action = yield take(GET_COLLECTION_LANDING_PAGE)
    const { payload } = action

    yield fork(generalSaga, getCollectionLandingPage, payload)
  }
}
